import React, { useState } from 'react';
import {
  Row,
  Col,
  Input,
  Typography,
  Table,
  Space,
  Tag,
  Statistic,
  Skeleton,
  Result
} from 'antd'
import {
  FaSearch,
} from "react-icons/fa"; //Font Awesome 5
// import dayjs from 'dayjs';
import DeletePopupButton from './components/DeletePopupButton';
import EditFormModal from './components/EditFormModal';
import AddFormModal from './components/AddFormModal';
import { useQuery } from '@tanstack/react-query';

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    // render: text => <Typography.Paragraph style={{ textAlign: 'right' }}>{text}</Typography.Paragraph>
    // align:'right'
  },
  // {
  //   title: 'Start Date',
  //   dataIndex: 'start_date',
  //   key: 'start_date',
  //   render: text =>dayjs(text).format('DD-MM-YYYY')
  // },
  // {
  //   title: 'End Date',
  //   dataIndex: 'end_date',
  //   key: 'end_date',
  //   render: text =>dayjs(text).format('DD-MM-YYYY')
  // },
  // {
  //   title: 'Course Days',
  //   dataIndex: 'course_days',
  //   key: 'course_days',
  // },
  {
    title: 'Price',
    dataIndex: 'price',
    key: 'price',
    render: text => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14 }} />
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    width: '25%'
  },
  {
    title: 'Status',
    dataIndex: 'is_active',
    key: 'is_active',
    align: 'center',
    render: (_, record) => record.is_active ? <Tag color="green" style={{ borderRadius: '20px' }}>Actived</Tag> : <Tag color="red" style={{ borderRadius: '20px' }}>Inactive</Tag>
  },
  {
    title: '',
    dataIndex: 'action',
    key: 'action',
    render: (_, record) => (
      <Space size="middle">
        <EditFormModal data={record} />
        <DeletePopupButton data={record} />
      </Space>
    ),
  }
]

function List() {
  const [filterData, setFilterData] = useState(null);
  const categoriesQuery = useQuery({ queryKey: ['/api/categories/'] })
  const productsQuery = useQuery({ queryKey: ['/api/products/findCourses'] })


  if (categoriesQuery.isLoading || productsQuery.isLoading) {
    return <Skeleton active />
  }

  if (categoriesQuery.isError || productsQuery.isError) {
    return <Result status="error" title={categoriesQuery.error.message || productsQuery.error.message} />
  };

  const onSearch = e => {
    const s = e.target.value;
    const target = productsQuery.data.filter(f => f.name.includes(s) || f.category.name.includes(s))
    // const target = productsQuery.data.filter(f => f.name.includes(s))
    setFilterData(target);
  }


  // console.log('brandsQuery.data :', brandsQuery.data);
  // console.log('categoriesQuery.data :', categoriesQuery.data);
  // console.log('productsQuery.data :', productsQuery.data);
  return (
    <div >
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <Row justify='space-between'>
            <Col>
              <Typography.Title level={3}>
                Courses
              </Typography.Title>
            </Col>
            <Col>
              <AddFormModal course={productsQuery.data} />
            </Col>
          </Row>
        </Col>
        <Col xs={24} sm={12} >
          <Input
            placeholder="Search Course"
            prefix={<FaSearch />}
            onChange={onSearch} />
        </Col>
        <Col xs={24}>
          <Table
            rowKey={(record) => record._id}
            columns={columns}
            dataSource={filterData || productsQuery.data}
            scroll={{
              x: 800,
            }}
          />
        </Col>
      </Row>
    </div>
  )
}

export default List